export const runScript = async (script: string) => {
  try {
    const fn = new Function(script);
    await fn();
  } catch (e) {
    Errors.report(e, {
      script,
    });
  }
};
